import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from "react";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from "react-toastify";
import HospitalLogin from "./pages/HospitalLogin";
import HospitalDashboard from "./pages/HospitalDashboard";
import HospitalAppointmentList from "./pages/HospitalAppointmentList";
import HospitalProfile from "./pages/HospitalProfile";
import Error404 from "./pages/Error404";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HospitalLogin />} />
        <Route path="/dashboard" element={<HospitalDashboard />} />
        <Route path="/appointments" element={<HospitalAppointmentList />} />
        <Route path="/profile" element={<HospitalProfile />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
      <ToastContainer position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;


